<template>
  <div class="row pl-lg-3 pr-lg-3">
    <div class="col-12">
      <template v-if="active">
        <Form
          :has-items="hasItems"
          :item="item"
          :editting="editting"
          :academic-year-id="academicYearId"
          :region="region"
          :select-region="selectRegion"
          :exclude-region="excludeRegion"
          :municipality="municipality"
          :select-municipality="selectMunicipality"
          :exclude-municipality="excludeMunicipality"
          :schools-added="schoolsAdded"
          :tap-request-id="tapRequestId"
          @submit="forwardSubmitEvent"
          @cancel="$emit('cancel')"
        />
      </template>
      <template v-else>
        <FormReadOnly
          :readonly="readonly"
          :item="item"
          :academic-year-id="academicYearId"
          :region="region"
          :municipality="municipality"
          :select-municipality="selectMunicipality"
          :tap-request-id="tapRequestId"
          @edit="$emit('edit')"
          @remove="$emit('remove')"
        />
      </template>
    </div>
  </div>
</template>

<script>
import Form from './_components/Form';
import FormReadOnly from './_components/FormReadOnly';

export default {
  name: 'SchoolRecommendationForm',
  components: {
    Form,
    FormReadOnly,
  },
  props: {
    academicYearId: { type: [Number, String], required: true, default: null },
    region: { type: Object, default: null },
    selectRegion: { type: Boolean, default: false },
    excludeRegion: { type: Boolean, default: false },
    municipality: { type: Object, default: null },
    selectMunicipality: { type: Boolean, default: false },
    excludeMunicipality: { type: Boolean, default: false },
    hasItems: { type: Boolean, default: false },
    schoolsAdded: { type: Array, required: true, default: () => [] },
    /* SchoolRecommendationModel */
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    active: { type: Boolean, default: true },
    tapRequestId: { type: [Number, String], required: true, default: null },
  },
  methods: {
    forwardSubmitEvent(...params) {
      this.$emit('submit', ...params);
    },
  },
};
</script>
